export { default } from './uniBuddy';
export type { Props, Props as UniBuddyPopCardProps } from './uniBuddy';
